module.exports = __webpack_public_path__ + "static/img/wuhan.976595c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/wuhan.png
// module id = q+6O
// module chunks = 1